import React, { useEffect, useRef, useState } from 'react';
import { CATEGORIAS, VENDEDORES } from './regras';

// Mesmos filtros da tela antiga; os aplicados aparecem como etiquetas removíveis
export const NOMES_FILTRO = {
  estados: 'Estado',
  cidades: 'Cidade',
  instituicoes: 'Instituição',
  cursos: 'Curso',
  categoriaStatus: 'Status',
  statusGrupo: 'Situação',
  siglas: 'Sigla',
  anos: 'Ano',
  vendedores: 'Vendedor'
};
const PRINCIPAIS = ['estados', 'cidades', 'instituicoes', 'cursos', 'categoriaStatus', 'siglas'];
const MAIS = ['statusGrupo', 'anos', 'vendedores'];
const MAX_OPCOES = 150;

export function rotuloValor(campo, valor) {
  if (campo === 'categoriaStatus' && CATEGORIAS[valor]) return CATEGORIAS[valor].rotulo;
  return valor;
}

function opcoesDe(campo, opcoes) {
  if (campo === 'categoriaStatus') return ['EM NEGOCIAÇÃO', 'FECHADOS', 'PERDIDO'];
  if (campo === 'statusGrupo') return (opcoes.statusGrupo && opcoes.statusGrupo.length) ? opcoes.statusGrupo : ['Livre', 'Vinculado'];
  if (campo === 'vendedores') return VENDEDORES.map(v => v.nome);
  return opcoes[campo] || [];
}

function useFecharAoClicarFora(aberto, fechar) {
  const ref = useRef(null);
  useEffect(() => {
    if (!aberto) return undefined;
    const aoClicar = (e) => { if (ref.current && !ref.current.contains(e.target)) fechar(); };
    const aoTeclar = (e) => { if (e.key === 'Escape') fechar(); };
    document.addEventListener('mousedown', aoClicar);
    document.addEventListener('keydown', aoTeclar);
    return () => {
      document.removeEventListener('mousedown', aoClicar);
      document.removeEventListener('keydown', aoTeclar);
    };
  }, [aberto, fechar]);
  return ref;
}

function ListaOpcoes({ campo, opcoes, filtros, onAlternar }) {
  const [termo, setTermo] = useState('');
  const todas = opcoesDe(campo, opcoes);
  const busca = termo.trim().toLowerCase();
  const encontradas = busca ? todas.filter(v => String(rotuloValor(campo, v)).toLowerCase().indexOf(busca) >= 0) : todas;
  const selecionadas = filtros[campo] || [];
  // Listas grandes (milhares de cidades/instituições): mostra as selecionadas e as primeiras encontradas
  const visiveis = encontradas.slice(0, MAX_OPCOES);
  selecionadas.forEach(v => { if (visiveis.indexOf(v) < 0) visiveis.unshift(v); });

  return (
    <React.Fragment>
      {todas.length > 8 && (
        <input type="search" value={termo} onChange={(e) => setTermo(e.target.value)} placeholder={`Procurar ${NOMES_FILTRO[campo].toLowerCase()}`} aria-label={`Procurar ${NOMES_FILTRO[campo]}`} />
      )}
      <div className="cx-opcoes">
        {visiveis.map(v => (
          <label key={v}>
            <input type="checkbox" checked={selecionadas.indexOf(v) >= 0} onChange={() => onAlternar(campo, v)} />
            {rotuloValor(campo, v)}
          </label>
        ))}
        {encontradas.length > MAX_OPCOES && <span className="cx-dica">Mostrando {MAX_OPCOES} de {encontradas.length.toLocaleString('pt-BR')}. Digite para achar outras.</span>}
        {encontradas.length === 0 && <span className="cx-dica">Nada encontrado.</span>}
      </div>
    </React.Fragment>
  );
}

function BotaoFiltro({ campos, nome, opcoes, filtros, onAlternar }) {
  const [aberto, setAberto] = useState(false);
  const ref = useFecharAoClicarFora(aberto, () => setAberto(false));
  const quantos = campos.reduce((total, c) => total + (filtros[c] || []).length, 0);

  return (
    <div className="cx-filtro" ref={ref}>
      <button type="button" className={quantos ? 'cx-ativo' : ''} aria-expanded={aberto} onClick={() => setAberto(!aberto)}>
        {nome}{quantos > 0 && <span className="cx-contador">{quantos}</span>}
      </button>
      {aberto && (
        <div className="cx-menu">
          {campos.map(campo => (
            <React.Fragment key={campo}>
              {campos.length > 1 && <span className="cx-titulo-menu">{NOMES_FILTRO[campo]}</span>}
              <ListaOpcoes campo={campo} opcoes={opcoes} filtros={filtros} onAlternar={onAlternar} />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BarraFiltros({ busca, onBusca, filtros, opcoes, ocultarVendedor, onAlternar, onLimparTudo }) {
  const mais = MAIS.filter(c => !(ocultarVendedor && c === 'vendedores'));
  const etiquetas = [];
  Object.keys(NOMES_FILTRO).forEach(campo => {
    if (ocultarVendedor && campo === 'vendedores') return;
    (filtros[campo] || []).forEach(valor => etiquetas.push({ campo, valor }));
  });

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div className="cx-filtros">
        <label className="cx-busca">
          <span role="img" aria-label="Buscar">🔍</span>
          <input type="search" value={busca} onChange={(e) => onBusca(e.target.value)} placeholder="Buscar curso, instituição, sigla, cidade ou vendedor" aria-label="Buscar" />
        </label>
        {PRINCIPAIS.map(campo => (
          <BotaoFiltro key={campo} campos={[campo]} nome={NOMES_FILTRO[campo]} opcoes={opcoes} filtros={filtros} onAlternar={onAlternar} />
        ))}
        <BotaoFiltro campos={mais} nome="Mais filtros" opcoes={opcoes} filtros={filtros} onAlternar={onAlternar} />
      </div>
      {etiquetas.length > 0 && (
        <div className="cx-chips">
          {etiquetas.map(({ campo, valor }) => (
            <span className="cx-chip" key={`${campo}:${valor}`}>
              {NOMES_FILTRO[campo]}: <b>{rotuloValor(campo, valor)}</b>
              <button type="button" aria-label={`Remover filtro ${NOMES_FILTRO[campo]} ${valor}`} onClick={() => onAlternar(campo, valor)}>✕</button>
            </span>
          ))}
          <button type="button" className="cx-link" onClick={onLimparTudo}>Limpar tudo</button>
        </div>
      )}
    </div>
  );
}
